<template>
  <div class="interior">
    <div class="interior-section" data-section="1" data-anim>
      <div class="full-section__background"></div>
      <div class="full-section__foreground">
        <div class="interior-section__title anim anim-start-1">
          Интерьерные решения
        </div>
        <h2 class="interior-section__subtitle anim anim-start-2">
          В рамках каждого концепта, помимо кухонь, LITHIUM также предлагает
          гостиные, гардеробные и мебель для ванных комнат в едином стиле,
          позволяя создать пространство, в котором вся мебель говорит на одном
          языке.
        </h2>
      </div>
    </div>
    <div class="page-nav">
      <div class="page-nav__item page-nav__item--active">ШКАФЫ И ГАРДЕРОБЫ</div>
      <div class="page-nav__item">ВАННЫЕ КОМНАТЫ</div>
      <div class="page-nav__item">СТЕНОВЫЕ ПАНЕЛИ</div>
    </div>
    <div class="interior-section" data-section="slider">
      <p class="text anim anim-scene-1" data-anim>
        При проектировании Harizma ключевой задачей было столкнуть прагматизм и
        эстетику. Убрали все сложности.<br />
        Результат - оригинальный дизайн с четкими линиями, где минимальное
        количество элементов используется по максимуму.
      </p>
      <div class="slider slider--1" data-anim>
        <swiper :options="swiperOption" ref="cardSwiper">
          <swiper-slide>
            <img src="@/assets/img/interior/int2.jpg" alt="" class="slide__img anim anim-scene-1 hide-lg" />
            <img src="@/assets/img/interior/mob/mob5.jpg" alt="" class="slide__img anim anim-scene-1 show-mob" />
            <span class="slide__pagi anim anim-scene-2">01</span>
            <!--            <span class="slide__pagi anim anim-scene-3 show-mob">Безукоризненные шкафы премиум-класса</span>-->
          </swiper-slide>
          <swiper-slide>
            <img src="@/assets/img/interior/int9.jpg" alt="" class="slide__img anim anim-scene-2" />
            <span class="slide__pagi anim anim-scene-3">02</span>
            <!--            <span class="slide__pagi anim anim-scene-3 show-mob">Безукоризненные шкафы премиум-класса</span>-->
          </swiper-slide>
          <swiper-slide>
            <img src="@/assets/img/interior/int3.jpg" alt="" class="slide__img anim anim-scene-3" />
            <span class="slide__pagi anim anim-scene-4">03</span>
            <!--            <span class="slide__pagi anim anim-scene-3 show-mob">Безукоризненные шкафы премиум-класса</span>-->
          </swiper-slide>
          <div class="swiper-button__prev" slot="button-prev"></div>
          <div class="swiper-button__next" slot="button-next"></div>
        </swiper>
      </div>
      <p class="text anim anim-scene-5 anim-scene-1-mob" data-anim>
        Мы предлагаем индивидуальные решения для единства планирования среды.
        Персональное производство мебели для столовой, гостиной, гардеробной и
        ванной комнаты в едином стиле. Гармония сочетания для домашний идиллии.
      </p>
    </div>
    <div class="interior-section" data-section="2">
      <img src="@/assets/img/interior/inter1.jpg" alt="" class="anim anim-scene-1" data-anim />
      <img src="@/assets/img/interior/inter3.jpg" alt="" class="anim anim-scene-2 anim-scene-1-mob" data-anim />
      <img src="@/assets/img/interior/inter2.jpg" alt="" class="anim anim-scene-3 anim-scene-1-mob" data-anim />
    </div>
    <div class="interior-section" data-section="3">
      <div class="text anim anim-scene-1" data-anim>
        <p>
          Эксклюзивные функциональные решения на особых условиях. Важные детали
          для искушенных клиентов. Эксклюзивные функциональные решения на особых
          условиях. Важные детали для искушенных клиентов. Эксклюзивные
          функциональные решения на особых условиях. Важные детали для
          искушенных клиентов.
        </p>
      </div>
      <div class="slider" data-anim>
        <div class="slider-inner">
          <swiper :options="cardSwiperInt" ref="cardSwiperInt">
            <swiper-slide>
              <img src="@/assets/img/interior/inter4.jpg" alt="" class="slide__img anim anim-scene-1" />
              <span class="slide__pagi anim anim-scene-2 show-mob">01</span>
            </swiper-slide>
            <swiper-slide>
              <img src="@/assets/img/interior/inter5.jpg" alt="" class="slide__img anim anim-scene-2" />
              <span class="slide__pagi anim anim-scene-3 show-mob">02</span>
            </swiper-slide>
          </swiper>
          <div class="slider-controls">
            <div class="slider-pagination anim anim-opacity-4" slot="pagination"></div>
            <div class="slider-scrollbar anim anim-opacity-5" slot="scrollbar"></div>
          </div>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </div>
      </div>
    </div>
    <div class="interior-section" data-section="4">
      <img src="@/assets/img/interior/inter1.jpg" alt="" class="item anim anim-scene-1" data-anim />
      <img src="@/assets/img/interior/inter3.jpg" alt="" class="item anim anim-scene-2 anim-scene-1-mob" data-anim />
      <div class="item" data-anim>
        <div class="item-title anim anim-scene-3 anim-scene-1-mob">
          Посмотрите гардеробные в шоуруме
        </div>
        <div class="item-text anim anim-scene-4 anim-scene-2-mob">
          Откройте для себя высококлассный подход LITHIUM. Составьте собственное
          впечатление.
        </div>
        <router-link to="/contacts" class="item-button anim anim-scene-5 anim-scene-3-mob">
          Контакты
        </router-link>
      </div>
    </div>

    <div class="show-mob">
      <div class="page-nav anim anim-scene-1" data-anim>
        <div class="page-nav__item">ШКАФЫ И ГАРДЕРОБЫ</div>
        <div class="page-nav__item page-nav__item--active">ВАННЫЕ КОМНАТЫ</div>
        <div class="page-nav__item">СТЕНОВЫЕ ПАНЕЛИ</div>
      </div>

      <div class="interior-section slider__mob" data-section="slider" data-anim>
        <p class="text anim anim-scene-1">
          В рамках каждого концепта, помимо кухонь, LITHIUM также предлагает
          гостиные, гардеробные и мебель для ванных комнат в едином стиле,
          позволяя создать пространство, в котором вся мебель говорит на одном
          языке.
        </p>
        <div class="slider slider--1">
          <swiper :options="swiperOption" ref="cardSwiper">
            <swiper-slide>
              <img src="@/assets/img/interior/mob/mob6.jpg" alt="" class="slide__img anim anim-scene-1" />
              <span class="slide__pagi anim anim-scene-2">01</span>
            </swiper-slide>
            <swiper-slide>
              <img src="@/assets/img/interior/mob/mob7.jpg" alt="" class="slide__img anim anim-scene-2" />
              <span class="slide__pagi anim anim-scene-3">02</span>
            </swiper-slide>
            <swiper-slide>
              <img src="@/assets/img/interior/mob/mob6.jpg" alt="" class="slide__img anim anim-scene-3" />
              <span class="slide__pagi anim anim-scene-4">03</span>
            </swiper-slide>
            <div class="swiper-button__prev" slot="button-prev"></div>
            <div class="swiper-button__next" slot="button-next"></div>
          </swiper>
        </div>
        <p class="text anim anim-scene-5">
          В рамках каждого концепта, помимо кухонь, LITHIUM также предлагает
          гостиные, гардеробные и мебель для ванных комнат в едином стиле,
          позволяя создать пространство, в котором вся мебель говорит на одном
          языке.
        </p>
      </div>

      <div class="page-nav anim anim-scene-1" data-anim>
        <div class="page-nav__item">ШКАФЫ И ГАРДЕРОБЫ</div>
        <div class="page-nav__item">ВАННЫЕ КОМНАТЫ</div>
        <div class="page-nav__item page-nav__item--active">СТЕНОВЫЕ ПАНЕЛИ</div>
      </div>

      <div class="interior-section" data-section="5" data-anim>
        <img src="@/assets/img/interior/mob/mob8.jpg" alt="" class="anim anim-scene-1" />
        <p class="text anim anim-scene-2">
          В рамках каждого концепта, помимо кухонь, LITHIUM также предлагает
          гостиные, гардеробные и мебель для ванных комнат в едином стиле,
          позволяя создать пространство, в котором вся мебель говорит на одном
          языке.
        </p>
      </div>
    </div>

    <Form />
    <NextSection title="Процессы и технологии" link="/process" image="interior/process.jpg"
      imageMob="interior/mob/process.jpg" />
  </div>
</template>

<script>
import NextSection from '@/components/common/NextSection'
import Form from '@/components/common/Form'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import anims from '@/mixins/anims'

export default {
  name: 'Interior',
  components: {
    swiper,
    Form,
    swiperSlide,
    NextSection
  },
  mixins: [anims],
  data () {
    return {
      swiperOption: {
        navigation: {
          nextEl: '.slider--1 .swiper-button__next',
          prevEl: '.slider--1 .swiper-button__prev'
        },
        slidesPerView: 'auto',
        spaceBetween: 28,
        breakpoints: {
          320: {
            spaceBetween: 15,
            freeMode: true
          },
          375: {
            spaceBetween: 18,
            freeMode: true
          },
          415: {
            spaceBetween: 20,
            freeMode: true
          },
          500: {
            spaceBetween: 24,
            freeMode: true
          },
          640: {
            spaceBetween: 24,
            freeMode: true
          },
          641: {
            centeredSlides: false,
            freeMode: false
          }
        },
        speed: 750,
        resistanceRatio: 0.5,
        simulateTouch: false,
        watchSlidesProgress: true
      },
      cardSwiperInt: {
        navigation: {
          nextEl: '[data-section="3"] .swiper-button-next',
          prevEl: '[data-section="3"] .swiper-button-prev'
        },
        slidesPerView: 1,
        spaceBetween: 28,
        speed: 750,
        resistanceRatio: 0.5,
        simulateTouch: false,
        watchSlidesProgress: true,
        scrollbar: {
          hide: false,
          el: '[data-section="3"] .slider-scrollbar',
          draggable: false,
          snapOnRelease: false,
          dragSize: 56
        },
        pagination: {
          el: '[data-section="3"] .slider-pagination',
          type: 'bullets',
          clickable: true,
          renderBullet: function (index, className) {
            return `
              <div class="slider-pagination__item ${className}">
                <span class="slider-pagination__id">0${index + 1}</span>
              </div>
            `
          }
        },
        breakpoints: {
          320: {
            spaceBetween: 15,
            freeMode: true,
            slidesPerView: 'auto'
          },
          375: {
            spaceBetween: 18,
            freeMode: true,
            slidesPerView: 'auto'
          },
          415: {
            spaceBetween: 20,
            freeMode: true,
            slidesPerView: 'auto'
          },
          500: {
            spaceBetween: 24,
            freeMode: true,
            slidesPerView: 'auto'
          },
          640: {
            spaceBetween: 24,
            freeMode: true,
            slidesPerView: 'auto'
          },
          641: {
            centeredSlides: false,
            freeMode: false
          }
        }
      },
      swiperOption2: {
        navigation: {
          nextEl: '.slider--2 .swiper-button-next',
          prevEl: '.slider--2 .swiper-button-prev'
        },
        slidesPerView: 'auto',
        spaceBetween: 28,
        breakpoints: {
          475: {
            spaceBetween: 16
          },
          320: {
            spaceBetween: 0
          }
        },
        speed: 750,
        resistanceRatio: 0.5,
        simulateTouch: false,
        watchSlidesProgress: true
      },
      swiperOption3: {
        navigation: {
          nextEl: '.slider--3 .swiper-button-next',
          prevEl: '.slider--3 .swiper-button-prev'
        },
        slidesPerView: 'auto',
        spaceBetween: 28,
        breakpoints: {
          475: {
            spaceBetween: 16
          },
          320: {
            spaceBetween: 0
          }
        },
        speed: 750,
        resistanceRatio: 0.5,
        simulateTouch: false,
        watchSlidesProgress: true
      },
      sliderOptionMob: {
        speed: 750,
        slidesPerView: 'auto',
        freeMode: true,
        loop: false,
        spaceBetween: 30,
        centeredSlides: true,
        breakpoints: {
          320: {
            spaceBetween: 15
          },
          375: {
            spaceBetween: 18
          },
          415: {
            spaceBetween: 20
          },
          500: {
            spaceBetween: 24
          }
        }
      }
    }
  },
  methods: {
    slideNext () {
      this.$refs.cardSwiper.swiper.slideNext()
    },
    slidePrev () {
      this.$refs.cardSwiper.swiper.slidePrev()
    }
  }
}
</script>

<style lang="scss" scoped>
.interior {
  background-color: #f2f2f2;

  &-container {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }

  &-section {
    display: flex;
    justify-content: flex-start;
    padding-left: vw(125);
    padding-right: vw(125);

    @include max-width(mobile) {
      padding-left: vw-m(27);
      padding-right: vw-m(27);
      flex-direction: column;
      overflow: hidden;
    }

    &__item {
      &-desc {
        @include text;
      }
    }

    &__images {
      align-items: flex-start;
    }

    &__img {
      display: block;
      max-width: 100%;
    }

    &__inner {
      display: flex;
      justify-content: flex-start;
    }

    &__card-text {
      @include max-width(mobile) {
        font-size: vw-m(18.5);
        color: #848689;
        font-weight: 300;
      }
    }

    &__desc {
      @include max-width(mobile) {
        width: 100% !important;
        padding-left: 0 !important;
        padding-right: 0 !important;
      }

      &-title {
        font-size: vw(38);
        margin-bottom: vw(21);
        color: #2e2e2e;

        @include max-width(mobile) {
          font-size: vw-m(44);
          line-height: 1.2;
          margin-bottom: vw-m(55);
        }
      }

      &-text {
        @include text;
        color: #37393b;
      }

      &-counter {
        color: #848689;
        display: inline-block;
        margin-top: vw-m(28);
        margin-bottom: vw-m(20);
        @include text;

        @include max-width(mobile) {
          font-size: vw-m(18.5);
          line-height: 1;
        }
      }
    }

    &[data-section="1"] {
      @include section-height;
      display: flex;
      position: relative;
      padding: 0;

      @include max-width(mobile) {
        height: 95vh;

        &+.page-nav {
          border-top: none;
        }
      }

      .full-section__background {
        background-image: url("~@/assets/img/interior/bg.jpg");
        background-position: center;
        background-size: cover;
        background-repeat: no-repeat;

        @include max-width(mobile) {
          background-position: 70% 50%;
        }
      }

      .full-section__foreground {
        @include foreground;
        padding-bottom: vw(308);

        @include max-width(mobile) {
          padding-bottom: vw-m(300);
          padding-left: vw-m(28);
          padding-right: vw-m(60);
          box-sizing: border-box;
        }
      }

      .interior-section__subtitle {
        @include section-subtitle;
        max-width: vw(510);
        font-size: vw(22);
        line-height: vw(26);
        margin-bottom: 0;
        letter-spacing: 0.01em;
        color: #ffffff;
        text-transform: initial;

        @include max-width(mobile) {
          max-width: 100%;
          font-size: vw-m(28);
          line-height: vw-m(37);
          font-family: "Helvetica";
          font-weight: 300;
        }
      }

      .interior-section__title {
        @include section-title;
        max-width: vw(480);
        font-size: vw(42);
        margin-bottom: vw(79);
        font-weight: 300;

        @include max-width(mobile) {
          max-width: 100%;
          font-weight: 300;
          font-size: vw-m(44);
          line-height: vw-m(54);
          margin-bottom: vw-m(77);
        }
      }

      .interior-section__text {
        @include section-desc;
      }
    }

    &[data-section="2"] {
      background-color: #fff;
      padding-top: vw(75);
      padding-bottom: vw(75);
      justify-content: center;
      align-items: center;

      img {
        width: vw(360);

        &:not(:last-child) {
          margin-right: vw(64);
        }

        @include max-width(mobile) {
          width: vw-m(472);

          &:not(:last-child) {
            margin-right: 0;
            margin-bottom: vw-m(34);
          }
        }
      }

      @include max-width(mobile) {
        padding-top: vw-m(0);
        padding-bottom: vw-m(96);
        background-color: transparent;
      }

      .interior-section__desc {
        width: vw(550);
        padding-left: vw(76);
        box-sizing: content-box;
      }

      .interior-section__images {
        width: 50%;
        align-self: flex-start;
      }
    }

    &[data-section="3"] {
      align-items: center;
      padding-bottom: vw(110);
      padding-top: vw(60);

      @include max-width(mobile) {
        padding-top: 0;
        padding-bottom: vw-m(96);
      }

      .text {
        width: 50%;

        @include max-width(mobile) {
          width: 100%;
        }

        p {
          width: vw(547);
          margin: 0 auto;
          font-size: vw(18);
          line-height: vw(26);
          color: #666666;

          @include max-width(mobile) {
            width: 100%;
            line-height: vw-m(37);
            font-size: vw-m(28);
            margin-bottom: vw-m(93);
            font-family: "Helvetica";
            font-weight: 300;
          }
        }
      }

      .slider {
        width: 50%;

        @include max-width(mobile) {
          width: 100%;
        }

        &-inner {
          margin: 0 auto;
          width: vw(546);
          position: relative;

          @include max-width(mobile) {
            width: 100%;
          }
        }

        .swiper-container {
          img {
            max-width: 100%;

            @include max-width(mobile) {
              width: vw-m(528);
            }
          }
        }

        @include max-width(mobile) {
          .swiper-slide {
            width: auto;
          }
        }

        &-pagination {
          display: flex;
          flex-flow: row nowrap;
          z-index: 1;

          & ::v-deep .slider-pagination__item {
            margin: 0;
            @include remove-tap-color;
            background: transparent;
            border-radius: initial;
            flex: 0 0 56px;
            width: 56px;
            height: 56px;
            opacity: 1;
            color: #fff;
            line-height: 1;

            &.swiper-pagination-bullet-active .-slider-pagination__id {
              color: #fff;
              opacity: 1;

              @include max-width(mobile) {
                color: #37393b;
                font-size: vw-m(25.5);
              }
            }

            @include max-width(xs) {
              font-size: 12px;
            }

            &:active {
              user-select: none;
            }
          }

          & ::v-deep .slider-pagination__id {
            font-size: vw(16);
            display: block;
            margin-bottom: vw(20);
            color: rgba(#fff, 1);
            font-weight: 300;
            transition: color $transition-basic;

            @include max-width(mobile) {
              display: flex;
              align-items: center;
              height: vw-m(38);
              color: #797979;
              font-size: vw-m(18);
              line-height: vw-m(38);
              transition: color 0.2s ease-out 0s, font-size 0.25s ease-out 0s;
            }
          }

          & ::v-deep .slider-pagination__title {
            font-size: vw(16);
            margin-bottom: vw(17);
            display: block;
          }

          & ::v-deep .slider-pagination__desc {
            font-size: vw(16);
            max-width: vw(260);
            display: block;
          }
        }

        &-controls {
          position: absolute;
          bottom: 0;
          left: vw(30);
          width: auto;
          z-index: 2;

          @include max-width(mobile) {
            left: vw-m(0);
            bottom: vw-m(-160);
            display: none;
          }
        }

        &-scrollbar {
          height: 6px;
          background: transparent;
          border-radius: 0;

          & ::v-deep .swiper-scrollbar-drag {
            background: #fff;
            height: 100%;
            border-radius: 0;
            z-index: 1;

            @include max-width(mobile) {
              background-color: #37393b;
              display: none;
            }
          }
        }

        .swiper-button-next {
          position: absolute;
          // cursor: url('~@/assets/img/catalog/diorama/arrow-next.png'), auto;
          cursor: pointer;
          cursor: url("~@/assets/svg/nav-arrow6.png"), auto;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0%;
          width: 100%;
          height: 100%;
          z-index: 2;
          background: none;
          margin: 0;
          outline: none !important;

          &.swiper-button-disabled {
            // cursor: url('~@/assets/img/catalog/diorama/arrow-next-dis.png'), auto;
            cursor: default;
            pointer-events: auto;
            z-index: 0;
          }

          @include max-width(mobile) {
            display: none;
          }
        }

        .swiper-button-prev {
          position: absolute;
          // cursor: url('~@/assets/img/catalog/diorama/arrow-prev.png'), auto;
          cursor: pointer;
          cursor: url("~@/assets/svg/nav-arrow7.png"), auto;
          top: 0;
          right: 0%;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: 1;
          background: none;
          margin: 0;
          outline: none !important;

          &.swiper-button-disabled {
            // cursor: url('~@/assets/img/catalog/diorama/arrow-prev-dis.png'), auto;
            cursor: default;
            pointer-events: auto;
          }

          @include max-width(mobile) {
            display: none;
          }
        }
      }

      @include max-width(mobile) {
        padding-bottom: vw-m(80);

        .interior-section__card-text {
          margin-bottom: vw-m(24);
        }

        .slide__pagi {
          font-size: vw-m(44);
          line-height: 1;
          height: auto;
          font-weight: 200;
          margin-top: vw-m(20);
          display: inline-block;
          letter-spacing: 0.01em;
          color: #cdcdcd;
        }
      }

      .interior-section__desc {
        width: vw(550);
        padding-left: vw(76);
        box-sizing: content-box;
      }

      .interior-section__images {
        width: 50%;
      }
    }

    &[data-section="4"] {
      background-color: #fff;
      padding-bottom: vw(75);
      padding-top: vw(75);
      justify-content: center;

      @include max-width(mobile) {
        background-color: transparent;
      }

      .item {
        width: vw(360);

        &:not(:last-child) {
          margin-right: vw(64);

          @include max-width(mobile) {
            margin-right: auto;
            margin-left: auto;
            margin-bottom: vw-m(34);
          }
        }

        @include max-width(mobile) {
          width: vw-m(472);

          &:last-child {
            margin-top: vw-m(54);
          }
        }

        &-title {
          font-size: vw(32);
          line-height: vw(42);
          letter-spacing: 0.01em;
          color: #2e2e2e;
          font-weight: 300;
          margin-bottom: vw(52);

          @include max-width(mobile) {
            font-size: vw-m(42);
            line-height: vw-m(50);
            margin-bottom: vw-m(61);
          }
        }

        &-text {
          font-size: vw(18);
          line-height: vw(26);
          color: #666666;
          margin-bottom: 32px;

          @include max-width(mobile) {
            width: 100%;
            line-height: vw-m(37);
            font-size: vw-m(28);
            margin-bottom: vw-m(31);
            font-family: "Helvetica";
            font-weight: 300;
          }
        }

        &-button {
          cursor: pointer;
          display: inline-block;
          font-size: vw(16);
          line-height: vw(19);
          color: #666666;
          padding: vw(11) vw(20) vw(12);
          border: 1px solid #666;

          @include max-width(mobile) {
            line-height: vw-m(31);
            font-size: vw-m(26);
            padding: vw-m(9) vw-m(17);
            color: #2e2e2e;
            border-color: #2e2e2e;
          }
        }
      }

      @include max-width(mobile) {
        padding-bottom: vw-m(160);

        .swiper-slide {
          width: vw-m(459);
        }

        &+.interior-section[data-section="3"] {
          padding-top: vw-m(45);
        }
      }

      .interior-section__img {
        width: vw(370);
        margin-right: vw(46);

        @include max-width(mobile) {
          display: none;
        }
      }
    }

    &[data-section="5"] {
      @include max-width(mobile) {
        padding-bottom: vw-m(106);

        img {
          padding-top: vw-m(114);
          padding-bottom: vw-m(96);
          width: 100%;
        }
      }
    }

    &[data-section="slider"].slider__mob {
      .swiper-slide {
        @include max-width(mobile) {
          img {
            height: auto;
            width: vw-m(528);
          }
        }
      }
    }

    &[data-section="slider"] {
      padding: vw(0) vw(25) vw(0) vw(140);
      display: block;

      @include max-width(mobile) {
        padding: vw-m(104) 0 vw-m(0) vw-m(32);
      }

      .text {
        padding-top: vw(100);
        padding-bottom: vw(75);
        max-width: vw(1150);
        color: #666;
        font-size: vw(18);
        line-height: vw(26);

        @include max-width(mobile) {
          padding-right: vw-m(32);
          padding-top: 0;
          padding-bottom: vw-m(95);
        }
      }

      .slider {
        width: 100%;
        position: relative;
        margin-bottom: vw-m(47);
      }

      .swiper-slide {
        width: auto;

        &:first-child {
          padding-left: vw(300);

          @include max-width(mobile) {
            padding-left: 0;
          }
        }

        @include max-width(mobile) {
          width: auto;
          height: auto;

          img {
            height: vw-m(350);
          }
        }
      }

      .swiper-button__prev {
        position: absolute;
        top: 0;
        left: 0%;
        right: 0%;
        bottom: 0;
        background-image: none;
        margin-top: 0;
        z-index: 1;
        cursor: pointer;
        cursor: url("~@/assets/svg/nav-arrow7.png"), auto;
        outline: none !important;

        &.swiper-button-disabled {
          opacity: 0;
          z-index: 0;
        }

        @include max-width(mobile) {
          display: none;
        }
      }

      .swiper-button__next {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 1;
        cursor: pointer;
        cursor: url("~@/assets/svg/nav-arrow6.png"), auto;
        outline: none !important;

        &.swiper-button-disabled {
          opacity: 0;
          z-index: 0;
        }

        @include max-width(mobile) {
          display: none;
        }
      }

      .swiper-slide {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
      }

      .slide__img {
        margin-bottom: vw(20);
        max-height: vw(575);

        @include max-width(mobile) {
          max-height: none;
          margin-bottom: vw-m(10);
        }
      }

      .slide__pagi {
        color: #999999;
        font-size: vw(22);
        height: vw(22);
        letter-spacing: 0.01em;
        font-weight: 300;

        @include max-width(mobile) {
          font-size: vw-m(44);
          line-height: 1;
          height: auto;
          font-weight: 200;
          margin-top: vw-m(20);
          display: inline-block;
          letter-spacing: 0.01em;
          color: #cdcdcd;
        }
      }
    }
  }

  .page-nav {
    display: flex;
    width: vw(1648);
    margin: 0 auto;
    padding: vw(13) 0 vw(14);
    border-bottom: 1px solid #999;
    align-items: center;
    justify-content: center;

    @include max-width(mobile) {
      width: auto;
      padding: vw-m(36) 0;
      margin: 0 vw-m(32);
      border-top: 1px solid #999;
    }

    &__item {
      font-size: vw(16);
      line-height: vw(28);
      text-align: center;
      letter-spacing: 0.08em;
      color: #cdcdcd;
      text-transform: uppercase;
      transition: color 0.25s ease 0s;

      &:not(:last-child) {
        margin-right: vw(200);

        @include max-width(mobile) {
          margin-right: vw-m(24);
        }
      }

      @include max-width(mobile) {
        font-size: vw-m(26);
        line-height: vw-m(28);
      }

      &--active {
        color: #666;
      }
    }
  }

  &-slider__mob,
  .show-mob {
    display: none;

    @include max-width(mobile) {
      display: block;
    }
  }

  .hide-lg {
    @include max-width(mobile) {
      display: none;
    }
  }

  @include max-width(mobile) {
    .text {
      font-size: vw-m(28) !important;
      line-height: vw-m(37) !important;
      font-family: "Helvetica";
      max-width: 100% !important;
      font-weight: 300;
      color: #666;
    }

    .next-section__right::after {
      display: none;
    }

    .swiper-slide {
      opacity: 0.75;
      transition: opacity 0.3s ease-out 0s;

      &-active {
        opacity: 1;
      }
    }
  }
}
</style>
